<!--  -->
<template>
    <div>
        <van-nav-bar
            :title="$t('platform.createAdd')"
            left-arrow
			fixed
            @click-left="$router.push('/AddressList')">
            <van-icon name="./static/img/ok.png" slot="right" @click="storeAddress()" style="font-size: 24px;"/>
        </van-nav-bar>
        <div class="contentWrapper">
			<van-field
				v-model="name"
				:label="$t('platform.name')"
				clearable
				:placeholder="$t('platform.inputName')"
			/>
		   <van-field
				v-model="price"
				:label="$t('platform.price')"
				clearable
				:placeholder="$t('platform.inputPrice')"
           />
		</div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            name:'',
            price:'',
        };
    },
    created(){

    },
    methods:{
		// 附加费创建
		storeAddress(){
			if(this.name && this.price){
				this.$axios({
					method: 'post',
					headers: {
						"Authorization": 'Bearer '+sessionStorage.token,
					},
					url: this.$build+'/api/additional/'+sessionStorage.actShopId+'/store',
					data:{
						name:this.name,
						price:this.price,
					}
				}).then(res => {
					if(res.data.status==200){
						console.log(res);
						this.$toast({
							type:'success',
							message:res.data.message,
                        });
                        var vm = this;
                        setTimeout(()=>{
                            vm.$router.push('/AddressList')
                        },1000)
					}else{
						for (var item in res.data.error) {
							this.$toast({
								type:'fail',
								message:res.data.error[item],
							});
						}
					}
				}).catch(err => {
					this.$toast({
						type:'fail',
						message:this.$t('StaffList.message'),
					});
				});
			}else{
				this.$toast({
					type:'fail',
					message:this.$t('NewDish.toast')
				});
			}
		}
    }
}

</script>
<style scoped>
	/deep/ .van-nav-bar .van-icon{
        font-size: 24px;
        color: #fff;
    }
	/deep/ .van-picker__cancel, /deep/ .van-picker__confirm{
		color: #2f75f7;
	}
</style>


// WEBPACK FOOTER //
// src/Address/CreatAddress.vue